// DDL
// create table
//   public.task_events (
//     id bigint generated by default as identity not null,
//     created_at timestamp with time zone not null default now(),
//     name text null,
//     task_id bigint null,
//     constraint task_events_pkey primary key (id),
//     constraint task_events_task_id_fkey foreign key (task_id) references tasks (id)
//   ) tablespace pg_default;

export type TaskEvent = {
  id: number;
  created_at: Date;
  name: string;
  task_id: number;
};

import { supabase } from '../supabase';

export const insertTaskEvent = async ({
  taskId,
  eventName,
}: {
  taskId: number;
  eventName: string;
}): Promise<void> => {
  const { error } = await supabase
    .from('task_events')
    .insert({ task_id: taskId, name: eventName });

  if (error) {
    console.error('Error inserting task event:', error);
    throw error;
  }
};

export const checkTaskEventExists = async ({
  taskId,
  eventName,
}: {
  taskId: number;
  eventName: string;
}): Promise<boolean> => {
  const { data, error } = await supabase
    .from('task_events')
    .select('id')
    .eq('task_id', taskId)
    .eq('name', eventName)
    .limit(1);

  if (error) {
    console.error('Error checking task event:', error);
    throw error;
  }

  return data && data.length > 0;
};
